import getPolyfillCss from "@store/Framework/Common/Utilities/getPolyfillCss";
import * as themeConfig from "./styleguide/config"; // eslint-disable-line spire/fenced-imports

export default getPolyfillCss(themeConfig);
